import React from "react";
import cx from "classnames";
import { Droppable } from "react-beautiful-dnd";
import MappingTag from "./MappingTag";

const MappingFieldCell = ({
  mappingId,
  mappingName,
  field,
  value,
  editing,
  edited,
  requiredFieldErrors,
  onRemove,
}) => {
  return (
    <div className="mapping__group__cell">
      <div
        className={cx("mapping__group__assignment__container", {
          "mapping__group__assignment__container--edited": edited && value,
          "mapping__group__assignment__container--error": requiredFieldErrors,
        })}
        id={field.name}
        data-fieldname={field.name}
      >
        {field.required && <div className="mapping__group__item--required">*Required</div>}
        <div className="mapping__group__item__title">{field.title}</div>
        <div className="mapping__group__item__subtitle">{field.description}</div>
        <Droppable droppableId={`mapping#${field.name}#${mappingId}`} isDropDisabled={!editing}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              className="mapping__group__assignment__dropzone"
              style={snapshot.isDraggingOver ? { borderColor: "#3246D3" } : null}
              data-testid={`dropzone-${mappingName}-${field.name}`}
            >
              <MappingTag
                mappingName={value}
                editing={editing}
                edited={edited}
                onRemove={() => onRemove(field.name)}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
};

export default MappingFieldCell;
